import store from "../../../store";
import { createLoading } from "../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callGetShortDetail = ({ id }) => store.dispatch(`${actionPrefix}/getShortDetail`, { id });

export const getShortDetail = ({ id }) => {
    setIsLoading(true);
    return callGetShortDetail({ id }).finally(() => setIsLoading(false));
};
